import * as Yup from 'yup'
import { getFromLocalStorage, transformStringDateFormatToDate } from '@/shared'

export const ValidationSchema = (node) => {
	const activeCompany = getFromLocalStorage('activeCompany')
	return Yup.object().shape({
		iin: Yup.string()
			.required({ key: 'required' })
			.matches(/^[0-9]+$/, 'not_correct_iin')
			.min(12, { key: 'min_12_length' })
			.max(12, { key: 'max_12_length' }),
		fullName: Yup.string().required({ key: 'required' }),
		contracts: Yup.string()
			.when(['isCombining', 'delegatingOrgBin'], {
				is: (isCombining, delegatingOrgBin) => isCombining === true || delegatingOrgBin,
				then: Yup.string().nullable(),
				otherwise: Yup.string().required({ key: 'required' }).nullable(),
			})
			.nullable(),
		tariffRate: Yup.number().required({ key: 'required' }),
		factSalary: Yup.string().required({ key: 'required' }),
		beginDate: transformStringDateFormatToDate().required({ key: 'required' }),
		substitutionIin: Yup.string()
			.when(['isReplacement'], {
				is: (isReplacement) => {
					return isReplacement === true
				},
				then: Yup.string().required({ key: 'required' }).nullable(),
				otherwise: Yup.string().nullable(),
			})
			.nullable(),
		substitutionName: Yup.string()
			.when('isReplacement', {
				is: (isReplacement) => isReplacement === true,
				then: Yup.string().required({ key: 'required' }).nullable(),
				otherwise: Yup.string().nullable(),
			})
			.nullable(),
		...(activeCompany?.msu ? {
			experienceCode: Yup.string().when([], {
				is: () => node.isLevelAndGradeOptional,
				then: Yup.string().nullable(),
				otherwise: Yup.string().required({ key: 'required' }).nullable(),
			}),
			unitCode: Yup.string().when([], {
				is: () => node.isLevelAndGradeOptional,
				then: Yup.string().nullable(),
				otherwise: Yup.string().required({ key: 'required' }).nullable(),
			}),
			...(!node.isLevelAndGradeOptional ? {
				levelCode: Yup.string().when(['unitCode'], {
					is: (unitCode) => !['8', '9', '10', '11'].includes(unitCode),
					then: Yup.string().required({ key: 'required' }).nullable(),
					otherwise: Yup.string().nullable(),
				}).nullable()
			} : {}),
		} : {}),
	})
}
